module.exports = __webpack_public_path__ + "img/Wallet.32dd2a06.png";